import React, {useEffect, useRef} from "react"
import {useMessage, useLocal} from "../AppContext"
import {Button} from "./Button"
import {iconCheckmark, iconInfo, iconWarning} from "../Helper/Icons"
import {layoutMessageTimeout} from "../settings"
import style from "./Message.css"

export const Message = () => {
    const message = useMessage()
    const local = useLocal()
    const box = useRef()
    const timer = useRef(null)

    const prevent = (event) => {
        event.stopPropagation()
        event.nativeEvent.stopImmediatePropagation()
    }

    const close = () => {
        message.close()
    }

    const confirm = () => {
        message.confirm()
    }

    useEffect(() => {
        if (message.hasMessage()) {

            clearTimeout(timer.current)
            box.current.classList.add(style.show)

            if (message.isError() || message.isSuccess()) {
                timer.current = setTimeout(close, layoutMessageTimeout)
            }

        } else {
            box.current.classList.remove(style.show)
        }

    }, [message.hasMessage(), message.getMessage()])

    return <div ref={box} className={style.message} onClick={prevent}>
        <div>
            <Icon/>
        </div>
        <div>
            <div className={style.text} dangerouslySetInnerHTML={{__html: message.getMessage()}}/>
            {message.isPrompt() && <div className={style.buttonSet}>
                <Button onClick={confirm}>{local.__("Ja")}</Button>
                <Button onClick={close}>{local.__("Nein")}</Button>
            </div>}
        </div>
    </div>
}

const Icon = () => {
    const message = useMessage()

    if (message.isError()) return <div className={`${style.icon} ${style.red}`}>{iconWarning}</div>
    if (message.isPrompt()) return <div className={style.icon}>{iconInfo}</div>
    return <div className={style.icon}>{iconCheckmark}</div>
}
